import { AxiosResponse } from "axios";
import React from "react";
import $ from "jquery";
import ReactDOM from "react-dom";
import { parseQueryResponseOnFail, parseQueryResponseOnFailResponse, usePickPropsIfNotNull } from "../../../declarations/common_utils";
import { IDataRepr } from "../../../intelws_portal/constructs/elements/Table";
import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { IConfigListElement } from "../admin/AdminSettings";

interface IPostAddLeadStatus extends AxiosResponse {
    data: {
        data: IConfigListElement
    }
}

interface IModalLeadServiceConfigurationAdd {
    leadServiceId: number,
    leadServiceName: string,
    mutator: (data: IConfigListElement) => void
}

function ModalLeadServiceConfigurationAdd(props: IModalLeadServiceConfigurationAdd) {
    const ENDPOINT = "api/settings/";

    const [errorObj, setErrorObj] = React.useState(getEmptyErrorObj);
    const [leadServiceName, setLeadServiceName] = React.useState("");
    const cancelTokenSource = React.useRef(getCancelToken());
    const [disable, setDisable] = React.useState(true);
   
    React.useEffect(() => {
        $("#leadServiceConfigurationAddModal").on("hidden.bs.modal", clearForm)
        return () => {
            cancelTokenSource.current.cancel();
            $("#leadServiceConfigurationAddModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        setLeadServiceName(props.leadServiceName);
    }, [props.leadServiceName])

    React.useEffect(() => {
        if (leadServiceName != "") {
            setDisable(false);
        } else {
            setDisable(true);
        }
    }, [leadServiceName])

    function clearForm() {
        setErrorObj(getEmptyErrorObj);
        setLeadServiceName("");
    }

    function getEmptyErrorObj() {
        return {
            lead_service_name: {
                isError: false,
                errorText: ""
            }
        }
    }

    function submitForm() {
        let formData = new FormData();
        formData.append("lead_service_name", leadServiceName);
        if (props.leadServiceId != -1) {
            formData.append("lead_service_id", props.leadServiceId.toString());
        }

        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, { section: "add_lead_service_name"} ) as Promise<IPostAddLeadStatus>
        requestResponse.then((response) => {
            props.mutator(response.data.data);
            $("#leadServiceConfigurationAddModal").modal("hide");
        }).catch((error) => {
            let [success, fail, failResponse] = parseQueryResponseOnFail(error);
            let errorObj = getEmptyErrorObj();
            parseQueryResponseOnFailResponse(errorObj, failResponse);
            setErrorObj(errorObj);
        })
    }

    function formFieldChange(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> , section: "leadServiceName") {
        if (section == "leadServiceName") {
            setLeadServiceName(e.target.value);
        }
    }
    
    function relativeRender() {
        return (
            <div className="modal fade custom-modal text-center" id="leadServiceConfigurationAddModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog text-left modal-lg" role="document">
                    <div className="modal-content">
                        <ModalHeader title={"Add Lead Service"} />
                        <div className="modal-body">
                            <ModalInputText onChange={(e) => formFieldChange(e, "leadServiceName")} value={leadServiceName} title={"Lead Service Name"}
                                required borderBottom isError={errorObj.lead_service_name.isError} errorText={errorObj.lead_service_name.errorText} /> <br />
                        </div>
                        <ModalFooter saveCallback={submitForm} saveInactive={false} disable={disable}/>
                    </div>
                </div>
            </div>
        )
    }

    return ReactDOM.createPortal(relativeRender(), document.getElementById('modal') as Element);
}

export default ModalLeadServiceConfigurationAdd;